import { Component, OnInit, QueryList, ContentChildren, AfterContentInit, AfterContentChecked, Input } from '@angular/core';
import { HrTabComponent } from '../hr-tab/hr-tab.component';
import { Observable } from 'rxjs';
import { startWith, delay, map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'hr-tab-group',
    templateUrl: './hr-tab-group.component.html',
    styleUrls: ['./hr-tab-group.component.scss'],
    standalone: false
})
export class HrTabGroupComponent implements OnInit, AfterContentInit, AfterContentChecked {

  constructor() { }
  ngAfterContentChecked(): void {
    if (!this.activeTab) {
      this.activeTabIndex = this.activeTabIndex || 0;
      Promise.resolve().then(() => {
        this.activeTab = this.tabs.toArray()[this.activeTabIndex];
      });
    }
  }

  ngAfterContentInit(): void {
    this.tabItems$ = this.tabs.changes
      .pipe(startWith(""))
      .pipe(delay(0))
      .pipe(map(() => this.tabs.toArray()));
  }

  selectTab(tabItem: HrTabComponent) {
    if (this.activeTab === tabItem) {
      return;
    }

    if (this.activeTab) {
      this.activeTab.isActive = false;
    }

    this.activeTab = tabItem;

    tabItem.isActive = true;
  }

  @ContentChildren(HrTabComponent)
  public tabs!: QueryList<HrTabComponent>;

  public tabItems$!: Observable<HrTabComponent[]>;

  public activeTab!: HrTabComponent;

  @Input()
  public activeTabIndex!: number;

  ngOnInit(): void {
  }
}
